import { render, staticRenderFns } from "./amortisasi.vue?vue&type=template&id=58038de7&scoped=true"
import script from "./amortisasi.vue?vue&type=script&lang=js"
export * from "./amortisasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58038de7",
  null
  
)

export default component.exports